import React from "react";
import Iterator from "../utils/Iterator";
import { Skeleton } from "../ui/skeleton";

function LoadingMenusProduct({ displayWaygrid }: { displayWaygrid: boolean }) {
  return (
    <div
      className={`flex gap-5 flex-col ${
        displayWaygrid
          ? "grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 gap-2"
          : ""
      }`}
    >
      <Iterator
        data={[1, 2, 3, 4]}
        render={() => (
          <div className="flex flex-col border-2 border-primary/20 shadow-card-shadow rounded-2xl overflow-hidden bg-background h-full">
            {/* Product image skeleton - full width on top */}
            <Skeleton
              className={`w-full ${
                displayWaygrid
                  ? "aspect-[4/3] md:aspect-[3/2]"
                  : "aspect-[5/3] md:aspect-[16/9]"
              }`}
            />

            {/* Content skeleton */}
            <div className="flex flex-col gap-3 p-3 md:p-4">
              {/* Product name and description */}
              <div className="flex flex-col gap-1.5">
                <Skeleton className="h-4 md:h-5 w-3/4" />
                <Skeleton className="h-3 md:h-4 w-full" />
                <Skeleton className="h-3 md:h-4 w-2/3" />
              </div>

              {/* Tags skeleton */}
              <div className="flex gap-1.5 flex-wrap min-h-[1.5rem]">
                <Skeleton className="h-5 w-12 rounded-full" />
                <Skeleton className="h-5 w-16 rounded-full" />
              </div>

              {/* Price skeleton */}
              <div
                className={`flex shrink-0 justify-end gap-1.5 ${
                  displayWaygrid ? "flex-row justify-between w-full" : "flex-col"
                }`}
              >
                <Skeleton className="h-4 md:h-5 w-16" />
                <Skeleton className="h-4 md:h-5 w-20" />
              </div>
            </div>
          </div>
        )}
      />
    </div>
  );
}

export default LoadingMenusProduct;
